import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoogleCalendarToNutshell = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 268 72",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "a-google-calendar-to-nutshell",
			width: 68,
			height: 67,
			x: 0,
			y: 1,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "luminance" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M67.467 1h-67v67h67z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#a-google-calendar-to-nutshell)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M51.598 16.869H16.335v35.263h35.263z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#EA4335",
					d: "m51.599 68 15.868-15.869-7.934-1.353L51.6 52.13l-1.45 7.26z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#188038",
					d: "M.467 52.131v10.58A5.29 5.29 0 0 0 5.757 68h10.578l1.63-7.934-1.63-7.935-8.645-1.353z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1967D2",
					d: "M67.467 16.869V6.289A5.29 5.29 0 0 0 62.178 1h-10.58q-1.447 5.903-1.447 8.688t1.448 7.18q5.265 1.508 7.934 1.508t7.934-1.508z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FBBC04",
					d: "M67.467 16.869H51.598v35.263h15.869z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34A853",
					d: "M51.598 52.131H16.335V68h35.263z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4285F4",
					d: "M51.598 1H5.756a5.29 5.29 0 0 0-5.29 5.29v45.84h15.87V16.869h35.262z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4285F4",
					d: "M23.569 44.224c-1.318-.89-2.231-2.19-2.73-3.91l3.06-1.26q.416 1.586 1.455 2.46c.687.581 1.525.868 2.503.868q1.5 0 2.579-.913t1.08-2.323q0-1.44-1.137-2.354c-.758-.608-1.71-.912-2.848-.912h-1.767v-3.028h1.587q1.467 0 2.472-.794 1.005-.793 1.005-2.173 0-1.229-.899-1.961-.899-.735-2.279-.736-1.35-.001-2.142.718a4.2 4.2 0 0 0-1.155 1.768l-3.028-1.261q.598-1.707 2.217-3.01 1.621-1.305 4.135-1.305 1.859-.001 3.34.718 1.483.722 2.324 1.992.839 1.275.837 2.861 0 1.62-.78 2.742a5.4 5.4 0 0 1-1.917 1.723v.18a5.8 5.8 0 0 1 2.46 1.919q.958 1.288.96 3.085c.002 1.797-.304 2.27-.912 3.209s-1.45 1.68-2.517 2.217c-1.071.538-2.275.812-3.61.812-1.547.004-2.975-.441-4.293-1.332m18.79-15.18L39 31.471l-1.68-2.548 6.026-4.346h2.31v20.501H42.36V29.043z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D4540",
			d: "M107.667 31.15a3.35 3.35 0 0 0 0 6.7zm62.669 5.719a3.35 3.35 0 0 0 0-4.738l-21.32-21.32a3.35 3.35 0 1 0-4.737 4.739l18.95 18.95-18.95 18.95a3.35 3.35 0 1 0 4.737 4.738zm-62.669.981h60.3v-6.7h-60.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FE5800",
			d: "M243.555 12.788a2.113 2.113 0 0 1-1.99-2.529l1.431-7.613q.04-.175.041-.354c0-1.616-2.263-1.827-5.194-1.827s-5.2.211-5.2 1.827q.002.18.041.354l1.451 7.613a2.14 2.14 0 0 1-.443 1.726 2.14 2.14 0 0 1-1.601.783c-14.028.49-23.924 5.084-23.924 13.46v3.225a1.55 1.55 0 0 0 .451 1.09 1.54 1.54 0 0 0 1.089.45h25.526a1.47 1.47 0 0 1 1.113.43 1.5 1.5 0 0 1 .434 1.11 1.434 1.434 0 0 1-1.227 1.438l-18.928 3.668a1.444 1.444 0 0 0-1.227 1.492v6.482c0 12.446 9.734 22.922 22.445 22.922a22.49 22.49 0 0 0 22.493-22.492V32.452a1.48 1.48 0 0 1 .956-1.387c.186-.072.385-.105.584-.099h4.09a1.54 1.54 0 0 0 1.567-1.54v-3.224c0-8.398-9.896-12.664-23.978-13.414"
		})
	]
});
export default SvgIconGoogleCalendarToNutshell;
